import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setupInterceptor } from './axios.config';

const InjectAxiosInterceptors = () => {
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    setupInterceptor(history, t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ history ]);

  // not rendering anything
  return null;
};

export default InjectAxiosInterceptors;